export default __webpack_public_path__ + "locales/lo-LA/ChangeUserTypeDialog.json?hash=7ab0cded26310a74017552ed0e6379b3";